<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <div class="member-msg">
            <div class="member-border">
              <el-avatar class="img" shape="circle" v-if="form.memberId && memberList.headImgUrl"
                :src="memberList.headImgUrl"></el-avatar>
              <el-avatar shape="circle" v-else :src="headerImg"></el-avatar>
              <div class="rows member-box" v-if="form.memberId">
                <p>{{ memberList.nickName }} {{ memberList.mobile ? memberList.mobile : memberList.idCardNo }}</p>
                <div class="flex-row mt5">
                  <p class="mobile">
                    来源门店：{{ memberList.shopName }}
                  </p>
                  <p>
                    可用余额:
                    <span class="fontSize18">￥{{ memberList.walletAmount }}</span>
                  </p>
                </div>
              </div>
              <div class="rows no-member" v-else>
                <p class="member-box">门店顾客</p>
              </div>
            </div>
          </div>
          <p class="order-title-boxs mtb24">
            <span class="blueBlock"></span><i>消费清单</i>
          </p>
          <div class="totals-box plr16">
            <el-row class="order-details">
              <el-col :span="10" class="pl10">商品名称</el-col>
              <el-col :span="3" class="divCenter">单价(元)</el-col>
              <el-col :span="3" class="divCenter">数量</el-col>
              <el-col :span="4" class="divCenter">小计(元)</el-col>

              <el-col :span="4" class="tRight pr10">实付(元)</el-col>
            </el-row>
            <div class="order-scoll">
              <!-- 准备做滑动 -->
              <el-row v-for="(item, index) in parentForm.orderItemList" :key="index" class="mt20 order-good-detail">
                <el-col :span="10" class="pl10">{{ item.itemName }}</el-col>
                <el-col :span="3" class="color999 divCenter">{{
                  item.salePrice
                }}</el-col>
                <el-col :span="3" class="color999 divCenter">{{
                  item.itemNum
                }}</el-col>
                <el-col :span="4" class="color999 divCenter">{{
                  item.itemNum * item.salePrice
                }}</el-col>

                <el-col :span="4" class="tRight pr10">{{
                  item.realPayAmount
                }}</el-col>
                <el-col :span="3" class="pl10 mt20 color999">技师：</el-col>
                <el-col :span="21" class="mt20 pr10">
                  <div class="jishi">
                    {{ item.staffNames }}
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <el-row class="orderTotal borderT fontSize18">
            <el-col :span="12" class="flex-row pb24">
              <p class="label">消费数量：</p>
              <p class="num">{{ parentForm.itemNum }}</p>
            </el-col>
            <el-col :span="12" class="flex-row pb24">
              <p class="label">合计金额：</p>
              <p class="money num">￥{{ parentForm.orderAmount }}</p>
            </el-col>
            <el-col :span="12" class="flex-row pb24">
              <p class="label">折扣优惠：</p>
              <span class="num moneys">￥{{ parentForm.discountAmount }}</span>
            </el-col>

            <el-col :span="12" class="flex-row pb24" v-if="form.memberId">
              <p class="label">卡券优惠：</p>
              <!-- <span class="num moneys" v-if="form.orderId&&isSelectCoupon">¥ {{ couponAmount }}</span> -->
              <!-- <span v-else>
								<span
									v-if="isSelectCoupon"
									@click="couponSelect()"
									class="num moneys"
									>¥ {{ couponAmount }}</span>
								<span
									v-else
									@click="couponSelect()"
									class="shopClass"
									>选择优惠券</span>
							</span> -->
              <span v-if="isSelectCoupon" @click="couponSelect()" class="num moneys">¥ {{ couponAmount }}</span>
              <span v-else>
                <span class="shopClass" v-if="form.orderId">无</span>
                <span v-else @click="couponSelect()" class="shopClass">选择优惠券</span>
              </span>
            </el-col>

            <el-col :span="12" class="flex-row">
              <p class="label">实收金额：</p>
              <p class="moneys num fontSize20">
                ￥{{
                  (
                    Number(parentForm.realPayAmount) -
                    Number(parentForm.couponAmount || 0)
                  ).toFixed(2)
                }}
              </p>
            </el-col>
          </el-row>
          <div class="pay-methods">
            <p class="order-title-boxs mtb24">
              <span class="blueBlock"></span><i>请选择收款方式</i>
            </p>
            <div class="plr24 flex-row wraps">
              <div v-for="(item, index) in payWayList" :key="index" @click="payWayFun(item)"
                class="flex-row orderPayRadio" :class="[radio == item.payCode ? 'active' : '']">
                <div class="pay-img">
                  <img :src="item.imgUrl" alt />
                </div>
                <div class="fontSize16">{{ item.payName }}</div>
                <div class="payCheak" v-if="radio == item.payCode">
                  <img src="../../../assets/images/new/payRadio.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns">
            <el-button class="left-btn" @click="pendingOrder" v-if="!isPayWay">挂单</el-button>
            <el-button class="right-btn" @click="confirmMoney">收款￥{{
              (
                Number(parentForm.realPayAmount) -
                Number(parentForm.couponAmount || 0)
              ).toFixed(2)
            }}</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <div v-if="parentForm.memberId != ''">
      <payDialog title="支付效验" :hide="dialogHide" :price="Number(
        (
          Number(parentForm.realPayAmount) -
          Number(parentForm.couponAmount || 0)
        ).toFixed(2)
      )
        " :type="'serveproduct'" :mobile="memberList.mobile" :memberId="memberList.id"
        :passwordTradeFlag="memberList.passwordTradeFlag" @changeDialog="savePay"></payDialog>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" center="" style="margin-top: 20vh;">
      <span style="text-align: center;display: inline-block;width: 100%;">确定要挂单吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveMoney">确 定</el-button>
      </span>
    </el-dialog>
    <pay-form ref="payEditForm" @payFun="payMoney" @rePay="refreshToken" :balance="balance" :amount="Number(
      (
        Number(parentForm.realPayAmount) -
        Number(parentForm.couponAmount || 0)
      ).toFixed(2)
    )
      " :foot="true"></pay-form>
    <quick-top-up ref="topUpForm" @handleChange="topUpPage" :isYuanJian="memberList.yuanjianTransferFlag"></quick-top-up>
    <member-top-up ref="memberTopUpForm" @memberChange="changeTopUp"></member-top-up>
    <confimDdialog ref="confimFrom" @handleChange="cashBack" :money="Number(
      (
        Number(parentForm.realPayAmount) -
        Number(parentForm.couponAmount || 0)
      ).toFixed(2)
    )" :payWay="radio"
      :payWayDescription="payWayDescription"></confimDdialog>
    <yuan-jian-pay ref="yuanJianForm" @change="yuanJianChange"></yuan-jian-pay>
    <selectCoupon-set ref="selectCouponSetForm" @selectCouponChange="selectCouponChange"></selectCoupon-set>
  </div>
</template>

<script>
import memberTopUp from "../member/topUp";
import minxin from "../../../assets/javascript/minxin.js";
import payDialog from "../../components/pay-dialog";
import confimDdialog from "../../components/confim-dialog";
import drawer from "../../../components/common/drawer";
import payForm from "../../components/pay";
import quickTopUp from "../../components/quick-top-up.vue";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
import YuanJianPay from "../../components/yuanJianPay.vue";
import selectCouponSet from "./selectCoupon.vue";
import { Loading } from 'element-ui'
export default {
  mixins: [minxin],
  components: {
    payDialog,
    drawer,
    payForm,
    quickTopUp,
    memberTopUp,
    confimDdialog,
    YuanJianPay,
    selectCouponSet,
  },
  data() {
    return {
      radio: "cash",
      payWayDescription: "现金",
      addEditShow: false,
      addEditTitle: "门店收银",
      dialogHide: false,
      dialogVisible: false,
      isYuanjianTakeIn: false, //远舰钱是否转入过来
      form: {
        orderId: "",
        payWay: "cash",
        verifyCode: "",
        payCheckType: "",
        couponSendRecordId: "",
      },
      headerImg: require("../../../assets/images/headerImg.png"),
      payWayList: [],
      parentForm: {
        memberId: "",
        realPayAmount: 0,
        couponAmount: 0,
      },
      isPayWay: false,
      isPay: false,
      memberList: {},
      isSacn: "",
      isSelectCoupon: false,
      couponSendRecordId: "",
      couponAmount: 0,
      balance: "",
    };
  },
  created() {
    this.init();
    this.isSacn = false;
  },
  mounted() {
    this.doIt();
  },
  methods: {
    back() {
      if (this.isPayWay) {
        this.$confirm("未支付订单将在不久后自动关闭，请尽快支付~", {
          confirmButtonText: "暂时放弃",
          cancelButtonText: "继续支付",
          center: true,
        }).then(() => {
          this.form = {
            orderId: "",
            payWay: "cash",
            verifyCode: "",
            payCheckType: "",
            couponSendRecordId: "",
          };
          this.parentForm = {
            memberId: "",
            realPayAmount: 0,
            couponAmount: 0,
          };
          this.orderId = "";
          this.isPayWay = false;
          this.isPay = false;
          this.$emit("change", true);
          this.addEditShow = false;
          this.balance = ''
          this.isSelectCoupon = false;
          this.couponAmount = 0;
          this.couponSendRecordId = "";
        });
      } else {
        this.addEditShow = false;
        this.isSelectCoupon = false;
        this.couponSendRecordId = "";
        this.parentForm.couponAmount = 0;
        this.couponAmount = 0;
        this.balance = ''
        this.form.couponSendRecordId = "";
      }
    },
    handleChangeDrawer() {
      this.addEditShow = false;
    },
    init() {
      this.$on("set", function (org) {
        this.addEditShow = true;
        this.isSacn = false;
        this.balance = ''
        this.form = org;
        if (this.form.memberId) {
          this.getMemberInfo();
        }
        this.isMember();
      });
    },
    getMemberInfo() {
      this.$api
        .get(this.$url.member.get, { id: this.form.memberId })
        .then((res) => {
          if (res) {
            this.memberList = res;
            if (this.isYuanjianTakeIn) {
              this.confirmMoney();
            }
          }
        });
    },
    doIt() {
      //此处添加500毫秒延迟，目的是等待历史记录变化之后再添加空地址，使空地址能准确添加到栈顶，防止出错
      setTimeout(() => {
        if (!(history.state && history.state.target == "Final")) {
          window.history.pushState(
            { target: "MeanSure", random: Math.random() },
            "",
            location.href
          );
          window.history.pushState(
            { target: "Final", random: Math.random() },
            "",
            location.href
          );
        }
        window.addEventListener(
          "popstate",
          function (e) {
            if (e.state && e.state.target == "MeanSure") {
              //此处可调用一些自定义的操作，例如弹窗提示之类的，最后根据实际需要可调用上面三个函数中的任何一个，用于决定当前自定义操作完成之后，需要停留在本页面，还是回退，还是跳转到其他页面
              // this.doSomething();
              //alert('不支持回退');
              // stay(); //如此操作会停留在本页面
              history.forward();
              //back();如此操作会无副作用回退到上一级
              //toUrl（'http://www.baidu.com'）;如此操作会执行完之定义操作之后跳转到百度
            }
          },
          false
        );
      }, 500);
    },
    payWayFun(item) {
      this.dialogHide = false;
      this.form.payWay = item.payCode;
      this.radio = item.payCode;
      this.payWayDescription = item.payName;
      this.getDiscountCalculate();
    },
    getDiscountCalculate() {
      this.$api
        .post(this.$url.order.discountCalculate, this.form)
        .then((res) => {
          if (res) {
            this.parentForm = res;
            this.parentForm.couponAmount = this.couponAmount;
          }
        });
    },
    isMember() {
      this.$api
        .get(this.$url.paywaySet.list, {
          isMember: this.form.memberId ? true : false,
          sourceFrom: "order",
        })
        .then((res) => {
          if (res) {
            this.payWayList = res;
            for (let i in this.payWayList) {
              if (i == 0) {
                this.form.payWay = this.payWayList[i].payCode;
                this.radio = this.payWayList[i].payCode;
                this.payWayDescription = this.payWayList[i].payName;
                this.$set(this.payWayList[i], "show", true);
              } else {
                this.$set(this.payWayList[i], "show", false);
              }
            }
            this.getDiscountCalculate();
          }
        });
    },
    savePay(org) {
      if (org != "") {
        this.form.payCheckType = org.payCheckType;
        this.form.verifyCode = org.verifyCode;
        if (!this.form.payWay) return this.$message.error("请选择支付方式")
        const loadingInstance = Loading.service({
          lock: true,
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$api
          .post(this.$url.order.pay, encrypt(JSON.stringify(this.form)))
          .then((res) => {
            console.log('res：' + res);
            if (res.constructor == Object) return
            if (res) {
              loadingInstance.close()
              this.dialogHide = false;
              this.isPayWay = false;
              this.isPay = false;
              this.orderId = res;
              if (this.form.payWay == "wallet") {
                this.balance = (
                  Number(this.memberList.walletAmount) -
                  (Number(this.parentForm.realPayAmount) -
                    Number(this.parentForm.couponAmount || 0))
                ).toFixed(2);
              }
              localStorage.removeItem("payMobile");
              this.$refs["payEditForm"].$emit("set", res);
            } else {
              loadingInstance.close()
            }
          })
      } else {
        this.dialogHide = false;
      }
    },
    payMoney(org) {
      if (org) {
        this.form = {
          orderId: "",
          payWay: "cash",
          verifyCode: "",
          payCheckType: "",
          couponSendRecordId: "",
        };
        this.parentForm = {
          memberId: "",
          realPayAmount: 0,
          couponAmount: 0,
        };
        this.orderId = "";
        this.isPayWay = false;
        this.isPay = false;
        this.$emit("change", true);
        this.addEditShow = false;
        this.isSelectCoupon = false;
        this.couponSendRecordId = "";
      }
      this.isSacn = false;
      console.log(this.isSacn);
    },
    topUpPage(org) {
      if (org && org != "yuanjian") {
        this.$refs["memberTopUpForm"].$emit("set", {
          memberId: this.memberList.id,
          mobile: this.memberList.mobile,
        });
      } else if (org && org == "yuanjian") {
        // yuanjianTransferFlag: true
        let obj = {
          payPrice: (
            Number(this.parentForm.realPayAmount) -
            Number(this.parentForm.couponAmount || 0)
          ).toFixed(2),
          memberId: this.memberList.id,
          mobile: this.memberList.mobile,
          type: "serveproduct",
        };
        // this.memberList.payPrice = (Number(this.parentForm.realPayAmount) - Number(this.parentForm.couponAmount || 0)).toFixed(2);
        this.$refs["yuanJianForm"].$emit("set", obj);
      }
    },
    changeTopUp(org) {
      if (org) {
        this.getMemberInfo();
        this.getDiscountCalculate();
      }
    },
    pendingOrder() {
      // 挂单
      if (this.isPayWay) return this.$message.error("已经开单，不可挂单");
      this.dialogVisible = true;
    },
    saveMoney() {
      // 挂单
      this.form.couponSendRecordId = this.couponSendRecordId;
      this.$api
        .post(
          this.$url.order.createForServeProduct,
          encrypt(JSON.stringify(this.form))
        )
        .then((res) => {
          if (res.constructor !== Object) {
            if (!res) return;
            this.isPay = false;
            this.isPayWay = false;
            this.form = {};
            this.$message.success("挂单成功");
            this.dialogVisible = false;
            this.addEditShow = false;
            this.$emit("change", true);
          } else {
            if (res.status == "accountAmountInsufficient") {
              localStorage.setItem(
                "payMobile",
                JSON.stringify({
                  //会员充值进入界面调用
                  id: this.parentForm.id,
                  mobile: this.memberList.mobile
                    ? this.memberList.mobile
                    : this.memberList.idCardNo,
                  path: this.$route.path,
                  res: this.parentForm,
                })
              );
              this.$refs["topUpForm"].$emit("set", "0");
            }
          }
        });
    },
    getToken() {
      this.$api.get(this.$url.order.getToken).then((res) => {
        if (res) {
          this.form.repeatToken = res;
        }
      });
    },
    //收款
    confirmMoney() {
      if (this.isSacn) return;
      console.log(this.isSacn, "isSacn");
      console.log(this.form.payWay, "payWay");

      if (this.form.payWay == "wallet") {
        this.$api
          .post(this.$url.repairDocument.checkMemberAccountAmount, {
            memberId: this.memberList.id,
            payWay: this.form.payWay,
            realPayAmount: (
              Number(this.parentForm.realPayAmount) -
              Number(this.parentForm.couponAmount || 0)
            ).toFixed(2),
            orderType: "serveproduct",
          })
          .then((res) => {
            if (res.constructor !== Object) {
              if (!res) return;
              this.trueConfirmMoney();
            } else {
              if (res.status == "accountAmountInsufficient") {
                localStorage.setItem(
                  "payMobile",
                  JSON.stringify({
                    id: this.form.id,
                    mobile: this.memberList.mobile
                      ? this.memberList.mobile
                      : this.memberList.idCardNo,
                    path: this.$route.path,
                    res: this.listSelected,
                  })
                );
                this.$refs["topUpForm"].$emit("set", "0");
              }
            }
          })
          .catch((error) => { });
      } else {
        this.trueConfirmMoney();
      }
    },
    trueConfirmMoney() {
      if (this.form.payWay == "wallet") {
        if (
          this.memberList.walletAmount <
          (
            Number(this.parentForm.realPayAmount) -
            Number(this.parentForm.couponAmount || 0)
          ).toFixed(2)
        ) {
          // this.noMoneyStatus = true;
          localStorage.setItem(
            "payMobile",
            JSON.stringify({
              //会员充值进入界面调用
              id: this.parentForm.id,
              mobile: this.memberList.mobile
                ? this.memberList.mobile
                : this.memberList.idCardNo,
              path: this.$route.path,
              res: this.parentForm,
            })
          );
          this.$refs["topUpForm"].$emit("set", "0");
        } else {
          if (this.isPay) return (this.dialogHide = true);
          this.form.couponSendRecordId = this.couponSendRecordId;
          this.$api
            .post(
              this.$url.order.createForServeProduct,
              encrypt(JSON.stringify(this.form))
            )
            .then((res) => {
              if (res.constructor !== Object) {
                if (!res) return this.getToken();
                this.form.orderId = res;
                localStorage.setItem("productType", "serveproduct");
                this.dialogHide = true;
                this.isPay = true;
                this.isPayWay = true;
                let a = [];
                this.payWayList.map((item) => {
                  if (item.payCode == this.form.payWay) {
                    a.push(item);
                  }
                });
                this.payWayList = a;
              } else {
                if (res.status == "accountAmountInsufficient") {
                  localStorage.setItem(
                    "payMobile",
                    JSON.stringify({
                      //会员充值进入界面调用
                      id: this.parentForm.id,
                      mobile: this.memberList.mobile
                        ? this.memberList.mobile
                        : this.memberList.idCardNo,
                      path: this.$route.path,
                      res: this.parentForm,
                    })
                  );
                  this.$refs["topUpForm"].$emit("set", "0");
                }
                this.getToken();
              }
            });
        }
      } else {
        if (this.isPay) return this.$refs["confimFrom"].$emit("set", true);
        this.form.couponSendRecordId = this.couponSendRecordId;
        this.$api
          .post(
            this.$url.order.createForServeProduct,
            encrypt(JSON.stringify(this.form))
          )
          .then((res) => {
            if (res && res.status != "fail") {
              if (res.status == "accountAmountInsufficient") {
                localStorage.setItem(
                  "payMobile",
                  JSON.stringify({
                    //会员充值进入界面调用
                    id: this.parentForm.id,
                    mobile: this.memberList.mobile
                      ? this.memberList.mobile
                      : this.memberList.idCardNo,
                    path: this.$route.path,
                    res: this.parentForm,
                  })
                );
                this.$refs["topUpForm"].$emit("set", "0");
                this.$api.get(this.$url.order.getToken).then((res) => {
                  if (res) {
                    this.form.repeatToken = res;
                  }
                });
                return;
              }

              this.form.orderId = res;
              this.$refs["confimFrom"].$emit("set", true);
              this.isPayWay = true;
              this.isPay = true;
              if (
                this.form.payWay == "tonglianStore" ||
                this.form.payWay == "yinlianStore"
              ) {
                this.isSacn = true;
                console.log(1);
              }
              let a = [];
              this.payWayList.map((item) => {
                if (item.payCode == this.form.payWay) {
                  a.push(item);
                }
              });
              this.payWayList = a;
            } else {
              this.$api.get(this.$url.order.getToken).then((res) => {
                if (res) {
                  this.form.repeatToken = res;
                }
              });
            }
          });
      }
    },
    cashBack(val) {
      // 现金确定弹窗回调
      if (val) {
        this.form.payCode = val;
        if (!this.form.payWay) return this.$message.error("请选择支付方式")
        const loadingInstance = Loading.service({
          lock: true,
          background: 'rgba(0, 0, 0, 0.7)'
        });
        console.log('zxlzl');
        this.$api
          .post(this.$url.order.pay, encrypt(JSON.stringify(this.form)))
          .then((res) => {
            console.log(res);
            
            if (res && res.status == "fail") {
              this.isPay = true;
              let parmar = {
                orderId: this.form.orderId,
                payWay: this.form.payWay,
                queryFlag: false,
                close: true,
                closeMessage: res.message,
              };
              loadingInstance.close()
              this.$refs["payEditForm"].$emit("set", parmar);
              return;
            }
            if (res && res.constructor !== Object) {
              if (
                this.form.payWay == "tonglianStore" ||
                this.form.payWay == "yinlianStore"
              ) {
                this.isSacn = true;
                console.log(3);
                this.isPayWay = false;
                this.isPay = false;
                let parmar = {
                  orderId: this.form.orderId,
                  payWay: this.form.payWay,
                  queryFlag: true,
                };
                loadingInstance.close()
                this.$refs["payEditForm"].$emit("set", parmar);
              } else {
                this.isPayWay = false;
                this.isPay = false;
                loadingInstance.close()
                this.$refs["payEditForm"].$emit("set", res);
              }
            }
            if (!res) loadingInstance.close()
          });
      } else {
        this.isSacn = false;
      }
    },
    yuanJianChange(org) {
      if (org) {
        this.isYuanjianTakeIn = true;
        this.getMemberInfo();
      }
    },
    refreshToken() {
      this.isPay = true;
      this.isSacn = false;
      this.isPayWay = true;
      this.$api.get(this.$url.order.getToken).then((res) => {
        if (res) {
          this.form.repeatToken = res;
        }
      });
    },
    couponSelect() {
      if (this.form.orderId) {
        return;
      }

      let a = [];
      console.log("111值：", this.parentForm);
      this.parentForm.orderItemList.map((item) => {
        let dic = { itemId: item.itemId, realPayAmount: item.realPayAmount };
        a.push(dic);
      });
      this.$refs["selectCouponSetForm"].$emit("set", {
        memberId: this.form.memberId,
        realPayAmount: this.parentForm.realPayAmount,
        orderItemList: a,
        couponSendRecordId: this.couponSendRecordId,
      });
    },
    selectCouponChange(org) {
      if (org.id) {
        console.log("折扣多少", Number(org.couponAmount), org);
        this.isSelectCoupon = true;
        this.couponSendRecordId = org.id;
        this.parentForm.couponAmount = org.couponAmount;
        this.couponAmount = org.couponAmount;
        this.form.memberId = this.form.memberId;
        console.log("值：", this.parentForm);
      } else {
        this.isSelectCoupon = false;
        this.couponSendRecordId = "";
        this.parentForm.couponAmount = 0;
        this.couponAmount = 0;
      }
    },
  },
};
</script>
<style>
.payway-success .el-button+.el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.pay-mains {
  .titles-head {
    border-top: 0;
  }

  .order-details {
    height: 56px;
    line-height: 56px;
    background: #f7f8fa;
  }

  .member-msg {
    padding: 16px 16px 0;

    .member-border {
      width: 100%;
      background-size: 100% 100%;
      color: white;
      display: flex;
      align-items: center;
      border-radius: 10px;
      padding: 12px 15px;
      background: #3388ff;
      box-sizing: border-box;

      .member-box {
        margin-left: 10px;

        .mobile {
          line-height: 1.6;
          margin-right: 10px;
        }
      }
    }
  }

  .titles {
    height: 48px;
    font-weight: 500;
    font-size: 18px;
    padding-left: 26px;
    border-bottom: 2px solid @borderColor;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .pay-methods {
    border-top: 10px solid #f5f5f5;
    margin-top: 20px;

    .orderPayRadio {
      box-sizing: border-box;
      width: 32%;
      height: 56px;
      background: #FFFFFF;
      border: 1px solid #DCDEE0;
      border-radius: 4px;
      align-items: center;
      padding-left: 16px;
      cursor: pointer;
      position: relative;
      margin-right: 2%;
      margin-bottom: 10px;

      &:nth-of-type(3n) {
        margin-right: 0 !important;
      }

      .payCheak {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 0;
        right: 0;
      }

      .pay-img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .active {
      color: #3388ff;
      border: 1px solid #3388ff;
      background: #eaf4fe;
    }
  }
}

.btns {
  width: 100%;
  display: flex;
  padding: 10px 24px 10px;
  border-top: 1px solid #eee;

  .left-btn {
    width: 176px;
    height: 56px;
    color: #fff;
    font-size: 20px;
    background: #535a6c;
    border-radius: 4px;
  }

  .right-btn {
    flex: 1;
    width: 100%;
    color: #fff;
    font-size: 20px;
    height: 56px;
    background: #ff5449;
    border-radius: 4px;
  }
}

.order-scoll {
  height: calc(100vh - 670px);
  overflow-y: auto;

  .order-good-detail {
    padding-bottom: 20px;
    border-bottom: 1px solid #ebedf0;
  }
}

.orderTotal {
  padding: 23px 25px 0;
}
</style>
